export default {
  paged: {
    select: 'id,messageType,to,subject,created,responseCode',
    searchSelect: ['to', 'subject'],
  },
  item: {
    select: 'id,messageType,from,replyTo,to,cc,bcc,subject,responseCode,errorMessage,created',
    expand: {
      processInstance: { select: 'name' },
      user: { select: 'fullName' },
    },
  },
};
